import { TTheme } from 'theme';

import { TTextVariant } from './Text.types';

export const VARIANT_FONT_SIZE: Record<TTextVariant, keyof TTheme['fontSizes']> = {
  title: 'xxl',
  subtitle: 'xl',
  sectionTitle: 'l',
  body: 'm',
  label: 's',
  caption: 'xs',
};

export const VARIANT_WEIGHT: Record<TTextVariant, keyof TTheme['fonts']> = {
  title: 'bold',
  subtitle: 'semiBold',
  sectionTitle: 'semiBold',
  body: 'regular',
  label: 'semiBold',
  caption: 'regular',
};

export const WEIGHT_VALUE: Record<keyof TTheme['fonts'], number> = {
  regular: 400,
  semiBold: 600,
  bold: 700,
};

/**
 * Leading tightens as type grows: at 28px a 1.35 ratio opens a gap wide enough to read as
 * two separate lines rather than one heading. The dense UI roles stay at 1.35, which is
 * what keeps rows, cells and inline labels on a predictable rhythm.
 */
export const VARIANT_LINE_HEIGHT: Record<TTextVariant, number> = {
  title: 1.2,
  subtitle: 1.25,
  sectionTitle: 1.3,
  body: 1.35,
  label: 1.35,
  caption: 1.35,
};
